<template>
  <div class="introducer-report">
    <el-tabs v-model="tabActive" type="border-card">
      <el-tab-pane label="Introducer" name="introducer">
        <IntroducerList />
      </el-tab-pane>
      <el-tab-pane label="Downline Report" name="downlinereport">
        <DownlineReport />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import IntroducerList from "./components/introducer-list";
import DownlineReport from "./components/downline-report";
export default {
  components: {
    IntroducerList,
    DownlineReport,
  },
  data() {
    return {
      tabActive: "introducer",
    };
  },
};
</script>

<style lang="scss">
.introducer-report {
  .search-area {
    margin-bottom: 10px;
  }
}
</style>
